module.exports = __webpack_public_path__ + "img/sql-user-group.cb10fa5a.png";